// extracted by mini-css-extract-plugin
module.exports = {"selection":"_bf6decb","label":"_c91f75b","disabled":"_292f8e7","odds":"_9b72610","buttonWrapper":"_28e5be1","showMoreWrapper":"_30faf98","showMore":"_5428ffa"};